import { yup } from '@guiker/yup-util'

export const payInMethodIdPathParamsSchema = yup.object({
  payInMethodId: yup.string(),
})

export type PayInMethodIdPathParams = yup.InferType<typeof payInMethodIdPathParamsSchema>
